import { QUERY_KEYS } from '@/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { Service } from '@/infra/services/activity';
import { ActivityDTO } from '@/core/dto/activity';

export interface GetActivityOptionsParams {
	organization_id: string;
	company_id: string;
	workstation_id: string;
}

const transformActivityOptions = (data: ActivityDTO[]) => {
	return data.map((activity) => ({ value: activity.id, label: activity.name }));
};

export const useGetActivityOptions = (params: GetActivityOptionsParams) => {
	return useQuery([QUERY_KEYS.GET_ACTIVITIES_OPTIONS, params], () => Service.listOptions(params), {
		enabled: !!params.organization_id && !!params.company_id && !!params.workstation_id,
		select: transformActivityOptions
	});
};
